/*
  Bundle tiers (snippet bundle-tiers.liquid). No dependencies; works with Dawn and most Online Store 2.0 themes.
  - Moves the theme's own variant picker into the first card (auto-detected, or Theme settings → Bundle offer →
    "Variant picker selector"), so the theme keeps driving gallery, price, stock and URL.
  - Extra pieces: any product, colour and size from /products.json (loaded only when the picker is first opened).
  - Add to cart with a multi-piece card selected adds the whole set in one /cart/add.js call, then refreshes the
    theme's cart drawer (Dawn-style cart-drawer / cart-notification) or goes to /cart.
    Other themes: set window.BundleTiers.onAdded = function (cartAddResponse) { ... } to open their own drawer.
*/
(function () {
  if (window.customElements.get('bundle-tiers')) return;

  var COLOUR_RE = /^(colou?r|couleur|farbe|kleur|colore|cor|shade)s?$/i;
  var SIZE_RE = /^(size|taille|gr(o|ö)(ss|ß)e|talla|maat|taglia|tamanho)s?$/i;
  var PICKERS = 'variant-selects, variant-radios, variant-picker, .product-form__variants, [data-variant-picker], .product-variant-picker, .selector-wrapper';
  var catalogue = null;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function idx(names, re) { for (var i = 0; i < names.length; i++) if (re.test(String(names[i]).trim())) return i; return -1; }

  var HEX = [[/black|noir|schwarz|negro|nero|preto/, '#111111'], [/white|blanc|weiss|weiß|blanco|bianco|ivory|off.?white/, '#FFFFFF'],
    [/grey|gray|gris|grau|grigio|charcoal|anthracite/, '#8A8B90'], [/wine|burgundy|bordeaux|maroon|oxblood/, '#5A1722'],
    [/red|rouge|rot|rojo|rosso/, '#C0282D'], [/rose gold/, '#C9988A'], [/pink|rose|rosa|blush/, '#E8B4C0'],
    [/olive|khaki|sage|green|vert|grün|verde/, '#55603F'], [/beige|sand|cream|nude|taupe|stone|camel/, '#D9CBB5'],
    [/brown|chocolate|mocha|coffee|marron|braun|marrón/, '#6B4A36'], [/purple|violet|lilac|lavender|plum|mauve/, '#7A5A93'],
    [/navy|marine/, '#1F2A44'], [/blue|bleu|blau|azul|blu|denim/, '#3C6FB4'], [/yellow|jaune|gelb|amarillo|mustard/, '#E2B93B'],
    [/orange|rust|terracotta/, '#D2691E'], [/silver/, '#C0C0C0'], [/gold/, '#C9A54C']];
  function hexFor(name) {
    var n = String(name || '').toLowerCase();
    for (var i = 0; i < HEX.length; i++) if (HEX[i][0].test(n)) return HEX[i][1];
    if (window.CSS && CSS.supports && CSS.supports('color', n)) return n;
    return '#CFCFCF';
  }

  // Whole catalogue (max 1,000 products), only products with something in stock
  function loadCatalogue(excludeTag) {
    if (catalogue) return catalogue;
    var all = [];
    function page(p) {
      return fetch(root() + 'products.json?limit=250&page=' + p).then(function (r) { return r.json(); }).then(function (j) {
        var list = j.products || [];
        all = all.concat(list);
        return list.length === 250 && p < 4 ? page(p + 1) : all;
      });
    }
    catalogue = page(1).then(function (list) {
      var ex = String(excludeTag || '').trim().toLowerCase();
      return list.filter(function (p) {
        var tags = (Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',')).map(function (t) { return String(t).trim().toLowerCase(); });
        return p.variants.some(function (v) { return v.available; }) && !/gift.?card/i.test(p.product_type + ' ' + p.handle) && !(ex && tags.indexOf(ex) > -1);
      }).map(function (p) {
        var names = p.options.map(function (o) { return o.name; });
        var ci = idx(names, COLOUR_RE), si = idx(names, SIZE_RE);
        var variants = p.variants.map(function (v) {
          return { id: v.id, options: [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }), price: Math.round(parseFloat(v.price) * 100), available: v.available };
        });
        var colours = [];
        if (ci > -1) variants.forEach(function (v) { if (v.available && colours.indexOf(v.options[ci]) === -1) colours.push(v.options[ci]); });
        var prices = variants.filter(function (v) { return v.available; }).map(function (v) { return v.price; });
        var size = function (src) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240' : ''; };
        return {
          key: String(p.id), title: p.title, type: p.product_type || '', tags: (p.tags || []).toString(),
          image: size(p.images && p.images[0] ? p.images[0].src : ''),
          images: (p.images || []).map(function (im) { return { src: size(im.src), ids: im.variant_ids || [] }; }),
          ci: ci, si: si, variants: variants, colours: colours,
          min: Math.min.apply(null, prices), max: Math.max.apply(null, prices)
        };
      });
    });
    return catalogue;
  }

  class BundleTiers extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.data = JSON.parse($('[data-bt-product]', this).textContent);
        this.t = JSON.parse($('[data-bt-strings]', this).textContent);
      } catch (e) { return; }
      this.section = this.closest('.shopify-section, section, main') || document;
      this.form = this.findForm();
      var names = this.data.options;
      this.ci = idx(names, COLOUR_RE);
      this.si = idx(names, SIZE_RE);
      this.qty = 1;
      this.slots = [];
      this.pickFor = -1;
      this.pieces = null;
      this.lastId = null;
      this.tiers = $$('[data-bt-tier]', this);
      this.main = $('[data-bt-main]', this);
      this.dialog = $('[data-bt-dialog]', this);
      this.list = $('[data-bt-list]', this);
      this.q = $('[data-bt-q]', this);
      this.msg = $('[data-bt-msg]', this);
      this.fmt = this.makeMoney();
      this.movePicker();
      this.bind();
      this.sync(true);
      this.selectTier(1);
      // The theme updates the variant id asynchronously (Dawn fetches the new variant's HTML): follow it cheaply
      var self = this;
      this._poll = setInterval(function () { if (document.body.contains(self)) self.sync(false); else clearInterval(self._poll); }, 400);
    }

    disconnectedCallback() { clearInterval(this._poll); this._ready = false; }

    // Same format as the theme's prices: read from a sample the store formatted (123456 cents → "€1.234,56", "$1,234.56"…)
    makeMoney() {
      var t = this.t, sample = String(t.moneySample || '');
      var m = sample.match(/^([\s\S]*?)1([^0-9]?)234([^0-9])56([\s\S]*)$/) || sample.match(/^([\s\S]*?)1([^0-9]?)23[45]()([\s\S]*)$/);
      if (m) {
        var pre = m[1], thou = m[2], dec = m[3], post = m[4];
        return function (cents) {
          var v = (Number(cents) || 0) / 100, s = dec ? v.toFixed(2) : String(Math.round(v)), parts = s.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
          return pre + parts[0] + (dec ? dec + parts[1] : '') + post;
        };
      }
      try {
        var nf = new Intl.NumberFormat(t.locale || undefined, { style: 'currency', currency: t.currency || 'EUR' });
        return function (cents) { return nf.format((Number(cents) || 0) / 100); };
      } catch (e) {
        return function (cents) { return ((Number(cents) || 0) / 100).toFixed(2); };
      }
    }

    findForm() {
      var forms = $$('form[action*="/cart/add"]', this.section).concat($$('form[action*="/cart/add"]'));
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('[type="submit"], button[name="add"]') && forms[i].querySelector('[name="id"]')) return forms[i];
      }
      return null;
    }

    movePicker() {
      var sel = (this.dataset.picker || '').trim() || PICKERS, self = this;
      var found = [];
      try { found = $$(sel, this.section).filter(function (el) { return !self.contains(el) && !el.closest('form[action*="/cart/add"] .bt'); }); } catch (e) { found = []; }
      // keep only outermost matches
      found = found.filter(function (el) { return !found.some(function (o) { return o !== el && o.contains(el); }); });
      var slot = $('[data-bt-picker-slot]', this);
      if (!found.length || !slot) { this.classList.add('bt--no-picker'); return; }
      found.forEach(function (el) { slot.appendChild(el); });
    }

    currentId() {
      var input = this.form && this.form.querySelector('[name="id"]');
      return input ? String(input.value) : String((this.data.variants.filter(function (v) { return v.available; })[0] || this.data.variants[0]).id);
    }

    mainVariant() {
      var id = this.currentId();
      return this.data.variants.filter(function (v) { return String(v.id) === id; })[0] || this.data.variants[0];
    }

    // Called on start, on changes and by the poll: refresh photo, prices and the button label when the variant changes
    sync(force) {
      var id = this.currentId();
      if (!force && id === this.lastId) { this.label(); return; }
      this.lastId = id;
      var mv = this.mainVariant(), src = mv.img || this.data.image;
      if (src) $$('[data-bt-main-img]', this).forEach(function (im) { im.removeAttribute('srcset'); im.src = src; });
      this.render();
    }

    slotListing(sl) {
      var pc = sl.pc, colour = sl.colour;
      var vs = pc.variants.filter(function (v) { return pc.ci < 0 || v.options[pc.ci] === colour; });
      var ids = vs.map(function (v) { return v.id; });
      var im = pc.images.filter(function (m) { return m.ids.some(function (id) { return ids.indexOf(id) > -1; }); })[0];
      return { vs: vs, img: im ? im.src : pc.image };
    }

    slotVariant(sl) {
      if (!sl) return null;
      var pc = sl.pc, L = this.slotListing(sl);
      return L.vs.filter(function (v) { return (pc.si > -1 ? v.options[pc.si] : String(v.id)) === sl.size; })[0] || null;
    }

    // Only the pieces actually chosen count; the free pieces come off once the set is complete (as at checkout)
    tierPrice(q, f) {
      var items = [this.mainVariant().price];
      for (var i = 0; i < q - 1; i++) { var v = this.slotVariant(this.slots[i]); if (v) items.push(v.price); }
      var total = items.reduce(function (a, b) { return a + b; }, 0), free = 0;
      if (items.length === q) { var sorted = items.slice().sort(function (a, b) { return a - b; }); for (var k = 0; k < f; k++) free += sorted[k]; }
      return { pay: total - free, total: total, n: items.length };
    }

    render() {
      var mv = this.mainVariant(), fmt = this.fmt, self = this;
      this.tiers.forEach(function (t) {
        var q = Number(t.dataset.qty), f = Number(t.dataset.free), pr = $('[data-bt-price]', t), cp = $('[data-bt-compare]', t);
        if (q === 1) { pr.textContent = fmt(mv.price); cp.textContent = mv.compare > mv.price ? fmt(mv.compare) : ''; }
        else {
          // Until every piece is picked the price would only be this piece's, so say what the set gives instead.
          var x = self.tierPrice(q, f), pending = x.n < q;
          t.classList.toggle('is-pending', pending);
          if (pending) { pr.textContent = self.t.freeN ? self.t.freeN.replace('__N__', f) : f + ' free'; cp.textContent = ''; }
          else { pr.textContent = fmt(x.pay); cp.textContent = x.total > x.pay ? fmt(x.total) : ''; }
        }
      });
      var mp = $('[data-bt-main-price]', this); if (mp) mp.textContent = this.qty > 1 ? fmt(mv.price) : '';
      this.label();
    }

    // "Add 3 to cart" while a set is selected; the theme's own text otherwise. Dynamic checkout buttons buy one item, so hide them for sets.
    label() {
      if (!this.form) return;
      var btn = this.form.querySelector('[type="submit"][name="add"], button[type="submit"]');
      if (btn) {
        var lab = btn.querySelector('span') || btn, mine = this.t.addN.replace('__N__', this.qty), now = lab.textContent.trim();
        if (this.qty > 1 && !btn.disabled) {
          if (now !== mine) { if (now !== this._mine) this._orig = lab.textContent; lab.textContent = mine; this._mine = mine; }
        } else if (this._mine && now === this._mine) {
          lab.textContent = this._orig; this._mine = null;                // back to the theme's own text
        }
      }
      $$('.shopify-payment-button, [data-shopify="payment-button"]', this.form).forEach(function (el) { el.style.display = this.qty > 1 ? 'none' : ''; }, this);
    }

    slotHTML(sl, i) {
      var t = this.t;
      if (!sl) {
        return '<li class="bt-slot is-empty"><button type="button" class="bt-slot__empty" data-bt-choose="' + i + '">' +
          '<span class="bt-slot__plus" aria-hidden="true">+</span>' +
          '<span class="bt-slot__body"><span class="bt-slot__n">' + esc(t.pieceN.replace('__N__', i + 2)) + '</span><span class="bt-slot__cta">' + esc(t.chooseAny) + '</span></span></button></li>';
      }
      var pc = sl.pc, L = this.slotListing(sl), v = this.slotVariant(sl), fmt = this.fmt;
      var h = '<li class="bt-slot"><span class="bt-slot__img">' + (L.img ? '<img src="' + esc(L.img) + '" alt="" width="120" height="150" loading="lazy">' : '') + '</span>' +
        '<div class="bt-slot__body"><div class="bt-slot__top"><span class="bt-slot__name">' + esc(pc.title) + '</span><span class="bt-slot__price">' + (v ? fmt(v.price) : '') + '</span></div>';
      if (pc.colours.length) {
        h += '<fieldset class="bt-opt"><legend class="bt-opt__lab">' + esc(t.colour) + ' <span>' + esc(sl.colour) + '</span></legend><div class="bt-dots">' +
          pc.colours.map(function (c) {
            return '<label class="bt-dot" title="' + esc(c) + '"><input type="radio" class="bt-sr" form="bt-none" name="bt-s' + i + '-c" value="' + esc(c) + '" data-bt-slot-colour="' + i + '"' + (c === sl.colour ? ' checked' : '') + '>' +
              '<span class="bt-dot__dot" style="--sw:' + hexFor(c) + '"></span><span class="bt-sr">' + esc(c) + '</span></label>';
          }).join('') + '</div></fieldset>';
      }
      if (pc.si > -1 || L.vs.length > 1) {
        var cur = v ? (pc.si > -1 ? v.options[pc.si] : v.options.join(' / ')) : '';
        h += '<fieldset class="bt-opt"><legend class="bt-opt__lab">' + esc(pc.si > -1 ? t.size : '') + ' <span>' + esc(cur) + '</span></legend><div class="bt-sizes">' +
          L.vs.map(function (x) {
            var lab = pc.si > -1 ? x.options[pc.si] : (x.options.join(' / ') || '-'), val = pc.si > -1 ? x.options[pc.si] : String(x.id);
            return '<label' + (x.available ? '' : ' class="is-oos"') + '><input type="radio" form="bt-none" name="bt-s' + i + '-s" value="' + esc(val) + '" data-bt-slot-size="' + i + '"' + (val === sl.size ? ' checked' : '') +
              (x.available ? '' : ' disabled aria-label="' + esc(lab + ', ' + t.soldOut) + '"') + '><span>' + esc(lab) + '</span></label>';
          }).join('') + '</div></fieldset>';
      }
      h += '<button type="button" class="bt-slot__change" data-bt-choose="' + i + '">' + esc(t.change) + '</button></div></li>';
      return h;
    }

    drawSlots() {
      var on = this.tiers.filter(function (t) { return t.classList.contains('is-on'); })[0], body = $('[data-bt-body]', on);
      this.tiers.forEach(function (t) { if (t !== on) { var b = $('[data-bt-body]', t); $$('.bt-slots', b).forEach(function (x) { x.remove(); }); } });
      if (this.main.parentNode !== body) body.insertBefore(this.main, body.firstChild);
      this.main.classList.toggle('is-set', this.qty > 1);
      var old = $('.bt-slots', body); if (old) old.remove();
      if (this.qty > 1) {
        var ol = document.createElement('ol'); ol.className = 'bt-slots';
        var h = ''; for (var i = 0; i < this.qty - 1; i++) h += this.slotHTML(this.slots[i], i);
        ol.innerHTML = h; body.appendChild(ol);
      }
      this.render();
    }

    selectTier(q) {
      this.qty = q;
      this.tiers.forEach(function (t) { var on = Number(t.dataset.qty) === q; t.classList.toggle('is-on', on); var r = $('input[name^="bt-tier-"]', t); if (r) r.checked = on; });
      if (this.msg) this.msg.hidden = true;
      this.drawSlots();
    }

    mainOption(i) { var mv = this.mainVariant(); return i > -1 ? mv.options[i] : ''; }

    pickSize(pc, vs) {
      var want = this.mainOption(this.si);
      var hit = vs.filter(function (v) { return v.available && pc.si > -1 && v.options[pc.si] === want; })[0] || vs.filter(function (v) { return v.available; })[0] || vs[0];
      return hit ? (pc.si > -1 ? hit.options[pc.si] : String(hit.id)) : '';
    }

    fillSlot(i, pc) {
      var mc = this.mainOption(this.ci);
      var colour = pc.ci > -1 ? (pc.colours.indexOf(mc) > -1 ? mc : (pc.colours[0] || null)) : null; // same colour = matching set
      var sl = { pc: pc, colour: colour, size: '' };
      sl.size = this.pickSize(pc, this.slotListing(sl).vs);
      this.slots[i] = sl;
      this.drawSlots();
    }

    listHTML(q) {
      var t = this.t, fmt = this.fmt;
      q = (q || '').toLowerCase().trim();
      var items = this.pieces.filter(function (pc) { return !q || (pc.title + ' ' + pc.type + ' ' + pc.tags).toLowerCase().indexOf(q) > -1; });
      if (!items.length) return '<p class="bt-muted">' + esc(t.noResults) + '</p>';
      return items.map(function (pc) {
        var price = pc.min === pc.max ? '<span>' + fmt(pc.min) + '</span>' : '<span>' + fmt(pc.min) + '</span> – <span>' + fmt(pc.max) + '</span>';
        return '<div class="bt-pick"><span class="bt-pick__img">' + (pc.image ? '<img src="' + esc(pc.image) + '" alt="" width="120" height="150" loading="lazy">' : '') + '</span>' +
          '<span class="bt-pick__body"><span class="bt-pick__name">' + esc(pc.title) + '</span><span class="bt-pick__price">' + price + '</span>' +
          (pc.colours.length > 1 ? '<span class="bt-pick__dots" aria-hidden="true">' + pc.colours.slice(0, 8).map(function (c) { return '<span style="--sw:' + hexFor(c) + '"></span>'; }).join('') + '</span>' : '') + '</span>' +
          '<button type="button" class="bt-pick__btn" data-bt-pick="' + esc(pc.key) + '">' + esc(t.choose) + '</button></div>';
      }).join('');
    }

    openPicker(i) {
      var self = this;
      this.pickFor = i;
      if (this.dialog.showModal) this.dialog.showModal(); else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('bt-noscroll');
      if (this.pieces) { this.list.innerHTML = this.listHTML(this.q.value); return; }
      loadCatalogue(this.dataset.excludeTag).then(function (all) { self.pieces = all; self.list.innerHTML = self.listHTML(self.q.value); })
        .catch(function () { self.list.innerHTML = '<p class="bt-muted">' + esc(self.t.error) + '</p>'; });
    }

    closePicker() { if (this.dialog.open) { if (this.dialog.close) this.dialog.close(); else this.dialog.removeAttribute('open'); } document.documentElement.classList.remove('bt-noscroll'); }

    say(text) { if (!this.msg) return; this.msg.textContent = text; this.msg.hidden = !text; }

    bind() {
      var self = this;
      this.dialog.addEventListener('close', function () { document.documentElement.classList.remove('bt-noscroll'); });
      this.dialog.addEventListener('click', function (e) {
        if (e.target === self.dialog || e.target.closest('[data-bt-close]')) { self.closePicker(); return; }
        var b = e.target.closest('[data-bt-pick]'); if (!b || self.pickFor < 0) return;
        var pc = self.pieces.filter(function (x) { return x.key === b.dataset.btPick; })[0];
        if (pc) {
          self.fillSlot(self.pickFor, pc); self.closePicker(); self.say('');
          var el = $$('.bt-slot', self)[self.pickFor]; if (el) el.scrollIntoView({ block: 'nearest' });
        }
      });
      var tq; this.q.addEventListener('input', function () { clearTimeout(tq); tq = setTimeout(function () { if (self.pieces) self.list.innerHTML = self.listHTML(self.q.value); }, 150); });
      this.addEventListener('click', function (e) { var c = e.target.closest('[data-bt-choose]'); if (c) { e.preventDefault(); self.openPicker(Number(c.dataset.btChoose)); } });
      this.addEventListener('change', function (e) {
        var t = e.target;
        if (t.name && t.name.indexOf('bt-tier-') === 0) { e.stopPropagation(); self.selectTier(Number(t.value)); return; }
        if (t.hasAttribute('data-bt-slot-colour')) {
          e.stopPropagation();
          var i = Number(t.dataset.btSlotColour), sl = self.slots[i]; sl.colour = t.value; sl.size = self.pickSize(sl.pc, self.slotListing(sl).vs); self.drawSlots(); return;
        }
        if (t.hasAttribute('data-bt-slot-size')) { e.stopPropagation(); self.slots[Number(t.dataset.btSlotSize)].size = t.value; self.drawSlots(); return; }
        setTimeout(function () { self.sync(false); }, 60);                // the theme's own picker: let it through, then follow
      });
      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(function () { self.sync(false); }, 0); });
      }
      // Intercept Add to cart (click and submit, capture phase) only while a multi-piece card is selected
      this._onClick = function (e) {
        if (self.qty < 2 || !self.form || !document.body.contains(self)) return;
        var btn = e.target.closest && e.target.closest('button[type="submit"], input[type="submit"], button[name="add"]');
        if (!btn || btn.form !== self.form && !self.form.contains(btn)) return;
        e.preventDefault(); e.stopImmediatePropagation(); self.addSet(btn);
      };
      this._onSubmit = function (e) {
        if (self.qty < 2 || e.target !== self.form || !document.body.contains(self)) return;
        e.preventDefault(); e.stopImmediatePropagation(); self.addSet(e.submitter || null);
      };
      document.addEventListener('click', this._onClick, true);
      document.addEventListener('submit', this._onSubmit, true);
    }

    addSet(btn) {
      var self = this, mv = this.mainVariant();
      this.form = this.findForm() || this.form;
      if (!mv.available) { this.say(this.t.soldOut); return; }
      var ids = [mv.id];
      for (var i = 0; i < this.qty - 1; i++) {
        var v = this.slotVariant(this.slots[i]);
        if (!v || !v.available) { this.say(this.t.needMore); this.openPicker(i); return; }
        ids.push(v.id);
      }
      var body = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
      var cartEl = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var dawn = cartEl && typeof cartEl.renderContents === 'function' && typeof cartEl.getSectionsToRender === 'function';
      if (dawn) { body.sections = cartEl.getSectionsToRender().map(function (s) { return s.section || s.id; }); body.sections_url = window.location.pathname; }
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.text().then(function (txt) {
            var j = null; try { j = JSON.parse(txt); } catch (e) { j = null; }
            if (!j) throw { message: self.t.error };                     // busy / error page instead of JSON
            if (!r.ok || j.status) throw j;                               // Shopify's own message, e.g. sold out
            return j;
          });
        })
        .then(function (json) {
          self.say('');
          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-tiers', productVariantId: mv.id, cartData: json });
          }
          document.dispatchEvent(new CustomEvent('bundle-tiers:added', { detail: json }));
          if (window.BundleTiers && typeof window.BundleTiers.onAdded === 'function') { window.BundleTiers.onAdded(json); return; }
          if (dawn) {
            var first = (json.items || [])[0] || {};
            cartEl.renderContents({ id: first.id, key: first.key, sections: json.sections || {} });
            cartEl.classList.remove('is-empty');
            return;
          }
          window.location.href = root() + 'cart';
        })
        .catch(function (err) { self.say((err && (err.description || err.message)) || self.t.error); })
        .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
    }
  }

  window.BundleTiers = window.BundleTiers || {};
  window.customElements.define('bundle-tiers', BundleTiers);
})();
